module.exports = __webpack_public_path__ + "static/msa-logo-9e660f69041e07114c1c8ce759ad88c8.svg";